<template>
  <v-card elevation="2" :max-width="maxWidthCard" class="mx-auto mt-4 mb-3">
    <v-card-title>
      <v-icon>mdi-information-variant</v-icon> Informações
      pessoais</v-card-title
    >
    <v-card-text>
      <v-alert v-show="showWelcome" color="blue-grey" dark class="my-0 py-0">
        <p
          class="my-0 py-4"
          style="
            font-size: 14px;
            line-height: 18px;
            text-align: justify;
            font-weight: normal;
          "
        >
          Bem-vindo ao Alertme 😊, para confirmar e finalizar sua compra
          precisamos de um pequeno cadastro para assegurar a autenticidade para
          o estabelecimento
        </p>
      </v-alert>
      <v-form>
        <v-container fluid>
          <v-row>
            <v-col cols="12" lg="4" sm="4">
              <v-text-field
                name="email"
                :value="$store.getters.getEmail"
                autocomplete="off"
                label="E-mail"
                :readonly="true"
                type="email"
              />
            </v-col>
            <v-col cols="12" lg="4" sm="4">
              <v-text-field
                v-model.trim="$v.perfil.name.$model"
                :error-messages="nomeErr"
                name="nome"
                autocomplete="off"
                label="Seu nome e sobrenome"
                type="text"
              />
            </v-col>
            <v-col cols="12" lg="2" sm="4">
              <v-text-field
                v-model.trim="$v.perfil.document.$model"
                :error-messages="cpfErr"
                name="cpf"
                autocomplete="off"
                label="Documento"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
                type="text"
              />
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
              <p class="h5 font-weight-bold mt-6">
                <v-icon>mdi-google-maps</v-icon>
                Dados de endereço
              </p>
            </v-col>
            <v-col cols="12" lg="2" sm="3" md="3">
              <v-text-field
                v-model.trim="$v.perfil.zip.$model"
                :error-messages="cepErr"
                name="cep"
                autocomplete="off"
                v-mask="['#####-###']"
                @blur="buscaCep"
                label="CEP"
                type="text"
              />
            </v-col>
            <v-col cols="12" lg="4" sm="4" md="4">
              <v-text-field
                :loading="loadingBuscaCep"
                :error-messages="logradouroErr"
                :disabled="loadingBuscaCep"
                v-model.trim="$v.perfil.address.$model"
                ref="logradouro"
                name="logradouro"
                autocomplete="off"
                label="Endereço"
                type="text"
              />
            </v-col>
            <v-col cols="12" lg="1" sm="2" md="2">
              <v-text-field
                v-model.trim="$v.perfil.number.$model"
                :error-messages="numeroErr"
                ref="numero"
                name="numero"
                autocomplete="off"
                label="N°"
                type="text"
              />
            </v-col>
            <v-col cols="12" lg="2" sm="2" md="2">
              <v-text-field
                ref="complemento"
                v-model.trim="perfil.complemento"
                :disabled="loadingBuscaCep"
                :loading="loadingBuscaCep"
                name="complemento"
                autocomplete="off"
                label="complemento"
                placeholder="Ex. Condomínio João, apto. 101"
                type="text"
              />
            </v-col>
            <!-- <v-col cols="12" lg="3" sm="3" md="3">
          <v-text-field
            v-model.trim="$v.perfil.info_ref.$model"
            name="info_ref"
            autocomplete="off"
            label="informações de referência"
            type="text"
          />
        </v-col> -->
            <v-col cols="12" lg="3" sm="3" md="3">
              <v-text-field
                v-model.trim="$v.perfil.district.$model"
                :error-messages="bairroErr"
                :loading="loadingBuscaCep"
                :disabled="loadingBuscaCep"
                name="bairro"
                ref="bairro"
                autocomplete="off"
                label="Bairro"
                type="text"
              />
            </v-col>
            <v-col cols="12" lg="3" sm="3" md="3">
              <v-text-field
                v-model.trim="$v.perfil.city.$model"
                :error-messages="cidadeErr"
                :loading="loadingBuscaCep"
                :disabled="loadingBuscaCep"
                ref="cidade"
                name="cidade"
                autocomplete="off"
                label="Cidade"
                type="text"
              />
            </v-col>
            <v-col cols="12" lg="1" sm="4" md="4">
              <v-select
                v-model.trim="$v.perfil.state.$model"
                :error-messages="ufErr"
                ref="uf"
                :items="$store.getters.getUf"
                label="UF"
                item-text="label"
                item-value="id"
              />
            </v-col>
            <v-col cols="12" class="d-flex justify-content-left">
              <v-checkbox
                v-model="$v.termo.$model"
                :error-messages="termoErr"
                label="Li e concordo"
                :disabled="disableTermo"
              >
              </v-checkbox>
              <v-btn
                color="primary"
                style="font-size: 12px"
                class="mt-5 py-0"
                height="27"
                text
                dark
                @click="showTermo = true"
              >
                ver termo
              </v-btn>
              <v-dialog v-model="showTermo" max-width="500">
                <v-card>
                  <v-card-title class="headline primary" style="color: #fff">
                    Termo de uso
                  </v-card-title>

                  <v-card-text class="text-justify py-4">
                    O Pague Fácil é uma plataforma de prestação de serviços para
                    pedidos e pagamentos, não fazemos parte ou sociedade com a
                    empresa que você está consumindo. Toda dúvida, nota fiscal,
                    sugestão ou reclamação relacionada ao produto adquirido
                    deverá ser encaminhada a empresa que você está consumindo.
                    <br />
                    O Pague Fácil está de acordo com a Nova Lei Geral de
                    Proteção de Dados, LGPD (Lei 13.709/18). <br />
                    Compartilhamos com a empresa que você está consumindo apenas
                    algumas informações como, dados de endereço para entrega,
                    seu nome e CPF caso você queira CPF na Nota Fiscal. Qualquer
                    dúvida referente a nossa empresa ou produto poderá nos
                    contatar no
                    <a href="mailto:suporte@paguefacil.online"
                      >suporte@paguefacil.online</a
                    >
                  </v-card-text>
                  <v-divider />
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      dark
                      @click="showTermo = false"
                      :disabled="!disableTermo"
                    >
                      OK
                    </v-btn>
                    <v-btn
                      color="primary"
                      dark
                      @click="aceiteTermo"
                      :disabled="disableTermo"
                    >
                      Aceito
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
            <v-spacer />
            <v-col cols="12" col="4" class="align-content-end">
              <v-btn
                :disabled="$v.$invalid || disableSubmit ? true : false"
                color="verde"
                dark
                class="font-weight-light"
                large
                right
                type="submit"
                @click.prevent="submit"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators";
import { existsProp, validaCpfCnpj } from "../../services/utils";

function checked(value) {
  return value === true ? true : false;
}
export default {
  name: "MinhaConta",
  data: () => {
    return {
      showWelcome: false,
      disableTermo: false,
      showTermo: false,
      termo: false,
      user: {
        email: "",
        password: ""
      },
      loadingBuscaCep: false,
      perfil: {
        name: "",
        document: "",
        zip: "",
        city: "",
        state: "",
        address: "",
        number: "",
        district: "",
        complemento: ""
      },
      maxWidthCard: "93%",
      disableBtn: false
    };
  },
  validations: {
    termo: { required, checked },
    perfil: {
      name: { required, minLength: minLength(6) },
      document: {
        required,
        validaCpfCnpj,
        minLength: minLength(11)
      },
      zip: { required, minLength: minLength(6) },
      city: { required, minLength: minLength(6) },
      state: { required, minLength: minLength(2) },
      address: { required, minLength: minLength(6) },
      number: { required },
      district: { required }
    }
  },
  computed: {
    termoErr() {
      const errors = [];
      const item = this.$v.termo;
      if (!item.$dirty) {
        return errors;
      }
      !item.required && errors.push("Termo é obrigatório");
      !item.checked && errors.push("Termo é obrigatório");
      return errors;
    },
    nomeErr() {
      const errors = [];
      const item = this.$v.perfil.name;
      if (!item.$dirty) {
        return errors;
      }
      !item.required && errors.push("Nome é obrigatório");
      !item.minLength && errors.push("Nome inválido");
      return errors;
    },
    cpfErr() {
      const errors = [];
      const item = this.$v.perfil.document;
      if (!item.$dirty) {
        return errors;
      }
      !item.required && errors.push("CPF é obrigatório");
      !item.validaCpfCnpj && errors.push("CPF é inválido");
      !item.minLength && errors.push("CPF inválido");
      return errors;
    },
    cepErr() {
      const errors = [];
      const item = this.$v.perfil.zip;
      if (!item.$dirty) {
        return errors;
      }
      !item.required && errors.push("CEP é obrigatório");
      !item.minLength && errors.push("CEP inválido");
      return errors;
    },
    cidadeErr() {
      const errors = [];
      const item = this.$v.perfil.city;
      if (!item.$dirty) {
        return errors;
      }
      !item.required && errors.push("Cidade é obrigatório");
      !item.minLength && errors.push("Cidade inválido");
      return errors;
    },
    ufErr() {
      const errors = [];
      const item = this.$v.perfil.state;
      if (!item.$dirty) {
        return errors;
      }
      !item.required && errors.push("UF é obrigatório");
      !item.minLength && errors.push("UF inválida");
      return errors;
    },
    logradouroErr() {
      const errors = [];
      const item = this.$v.perfil.address;
      if (!item.$dirty) {
        return errors;
      }
      !item.required && errors.push("Endereço é obrigatório");
      !item.minLength && errors.push("Endereço inválido");
      return errors;
    },
    numeroErr() {
      const errors = [];
      const item = this.$v.perfil.number;
      if (!item.$dirty) {
        return errors;
      }
      !item.required && errors.push("Número é obrigatório");
      return errors;
    },
    bairroErr() {
      const errors = [];
      const item = this.$v.perfil.district;
      if (!item.$dirty) {
        return errors;
      }
      !item.required && errors.push("Bairro é obrigatório");
      !item.minLength && errors.push("Bairro inválido");
      return errors;
    },
    disableSubmit: {
      set(value) {
        this.disableBtn = value;
      },
      get() {
        return this.disableBtn;
      }
    }
  },
  methods: {
    aceiteTermo() {
      this.showTermo = false;
      this.termo = true;
    },
    buscaCep() {
      this.loadingBuscaCep = true;
      let zip = this.perfil.zip.replace(/\D/g, "");
      let data = {
        hostId: this.$store.getters.hostActive,
        cep: zip
      };
      this.$alertme.buscaCepVmtech(data).then(
        res => {
          this.loadingBuscaCep = false;
          if (typeof res.data == Object) {
            this.$store.dispatch("setMsgError", res.data.message);
            this.$store.dispatch("setDisplayMsgErr", true);
            return;
          }
          let _result = res.data[0];
          this.perfil.address = _result.tlo_tx+' '+_result.log_no;
          this.perfil.city = _result.cidade[0].loc_no;
          this.perfil.state = _result.ufe_sg;
          this.perfil.district = _result.bairro[0].bai_no;
          this.$refs.numero.focus();
        },
        e => {
          this.loadingBuscaCep = false;
          console.log(e);
        }
      );
    },
    getPerfilHost(data){
      this.$alertme.getPerfil(data).then(
      res => {
        if (res.data.message != "ok") {
          this.showWelcome = true;
          this.disableTermo = false;
          this.$store.dispatch("setPerfil", {});
        } else {
          this.showWelcome = false;
          this.disableTermo = true;
          this.termo = true;
          if (
            Object.prototype.hasOwnProperty.call(res.data.value, "document")
          ) {
            this.$store.dispatch("setPerfil", res.data.value);
            let obj = this.$store.getters.getPerfil;
            let copy = Object.assign({}, this.perfil);
            this.perfil = Object.assign(copy, obj);
          }
        }
      },
      () => {
        this.$store.dispatch("setPerfil", {});
      }
    );
    },
    submit() {
      this.disableSubmit = true;
      let data = { ...this.perfil };
      this.$store.commit("setRedirect", "");
      data.hostId = this.$alertme.getHostIdUrl(this.$route);
      this.$alertme.setPerfil(data).then(
        res => {
          this.disableSubmit = false;
          if (res.data.message == "ok") {
            this.$store.dispatch("MsgSucces", "Perfil salvo com sucesso!");
            this.$store.dispatch("displayMsgSuccess", true);
            this.$store.dispatch("setPerfil", Object.assign({}, this.perfil));
            //
            let exists_cams = existsProp(this.$store.getters.infoHost,'cams')
            if(!exists_cams || (exists_cams && this.$store.getters.infoHost.cams<=0)) {
              this.$router.push({ name: "minha-assinatura" }).catch(() => {})
            }
          } else {
            this.$store.dispatch("setMsgError", res.data.message);
            this.$store.dispatch("setDisplayMsgErr", true);
          }
        },
        e => {
          this.disableSubmit = false;
          this.$store.dispatch("setMsgError", e.data.message);
          this.$store.dispatch("setDisplayMsgErr", true);
        }
      );
    }
  },
  props:{
    maxWidth:{
      type:String,
      default:()=> '93%'
    }
  },
  created() {
    this.maxWidthCard = !this.maxWidth ? "90%" : this.maxWidth;
    let data = {};
    data.hostId = this.$alertme.getHostIdUrl(this.$route);
    this.getPerfilHost(data)
  }
};
</script>